import React, { useMemo } from 'react';
import * as Sentry from '@sentry/react';
import { ApolloProvider } from '@apollo/client/react';
import { useAuthToken } from '@repo/hooks/useAuthToken';
import { makeClient } from '@/apollo';
import { markSessionExpired } from '@/features/auth/sessionExpired';
import { FormProviderFix } from '@repo/ui/Form';
import { IdleLogoutProvider } from '@repo/ui/IdleLogoutProvider';

import 'material-symbols';

type AppProviderProps = {
  children: React.ReactNode;
};

const AppProvider = ({ children }: AppProviderProps) => {
  const [token, setToken] = useAuthToken();
  const apolloClient = useMemo(
    () =>
      makeClient({
        authorization: token ? `Bearer ${token.token}` : null,
        // Clearing the token makes UserContext redirect to /login?redirect_to=…
        onUnauthorized: () => {
          markSessionExpired();
          setToken(null);
        },
      }),
    [token, setToken]
  );

  return (
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <ApolloProvider client={apolloClient}>
        <IdleLogoutProvider>
          <FormProviderFix>{children}</FormProviderFix>
        </IdleLogoutProvider>
      </ApolloProvider>
    </Sentry.ErrorBoundary>
  );
};

export default AppProvider;
